var _rect, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyRetentionRate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "money_retention_rate",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38.455,
    viewBox: "0 0 38 38.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1443",
    "data-name": "Rectangle 1443",
    width: 38,
    height: 38,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    transform: "translate(14.302 5.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4383",
    "data-name": "Path 4383",
    d: "M168.041,54.1a1.185,1.185,0,1,1-1.185-1.185A1.185,1.185,0,0,1,168.041,54.1Z",
    transform: "translate(-165.671 -52.912)",
    fill: "#fee96b"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Circle-2",
    "data-name": "Circle",
    transform: "translate(0.622 9.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4383-2",
    "data-name": "Path 4383",
    d: "M168.041,54.1a1.185,1.185,0,1,1-1.185-1.185A1.185,1.185,0,0,1,168.041,54.1Z",
    transform: "translate(-165.671 -52.912)",
    fill: "#abd67c"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Polygon",
    transform: "translate(29.235 26.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4384",
    "data-name": "Path 4384",
    d: "M176.238,72.532l2.1-3.641,2.1,3.641Z",
    transform: "translate(-176.238 -68.891)",
    fill: "none",
    stroke: "#5fb4f6",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Balance",
    transform: "translate(0.865 12.456)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 12.625,
    cy: 12.625,
    rx: 12.625,
    ry: 12.625,
    transform: "translate(0)",
    fill: "none",
    stroke: "#3c4043",
    strokeMiterlimit: 2.613,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4386",
    "data-name": "Path 4386",
    d: "M178.969,84.543a10.315,10.315,0,1,1-10.314-10.314A10.314,10.314,0,0,1,178.969,84.543Z",
    transform: "translate(-156.051 -71.939)",
    fill: "#abd67c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_812",
    "data-name": "Group 812",
    transform: "translate(8.359 3.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M170.262,77.459c-2.529-1.744-6.544-.763-6.544,2.845,0,4.405,6.8,3.077,6.8,7.278,0,4.29-5,5.322-7.263,2.33",
    transform: "translate(-163.254 -74.861)",
    fill: "none",
    stroke: "#3c4043",
    strokeMiterlimit: 2.613,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    y2: 18.73,
    transform: "translate(3.569)",
    fill: "none",
    stroke: "#3c4043",
    strokeMiterlimit: 2.613,
    strokeWidth: 1.5
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "percent-2",
    transform: "translate(25.146 2.957) rotate(-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_829",
    "data-name": "Group 829",
    transform: "translate(0.004 0.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_828",
    "data-name": "Group 828",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4455",
    "data-name": "Path 4455",
    d: "M10.487.147a.5.5,0,0,0-.706,0L.146,9.805a.5.5,0,1,0,.706.708L10.487.854A.5.5,0,0,0,10.487.147Z",
    fill: "#3c4043",
    stroke: "#3c4043",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_831",
    "data-name": "Group 831",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    "data-name": "Group 830"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4456",
    "data-name": "Path 4456",
    d: "M2.546,0A2.546,2.546,0,1,0,5.092,2.546,2.549,2.549,0,0,0,2.546,0Zm0,4.02A1.474,1.474,0,1,1,4.02,2.546,1.476,1.476,0,0,1,2.546,4.02Z",
    fill: "#3c4043",
    stroke: "#3c4043",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_833",
    "data-name": "Group 833",
    transform: "translate(5.46 7.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_832",
    "data-name": "Group 832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4457",
    "data-name": "Path 4457",
    d: "M2.546,0A2.546,2.546,0,1,0,5.092,2.546,2.549,2.549,0,0,0,2.546,0Zm0,4.02A1.474,1.474,0,1,1,4.02,2.546,1.476,1.476,0,0,1,2.546,4.02Z",
    fill: "#3c4043",
    stroke: "#3c4043",
    strokeWidth: 0.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyRetentionRate);
export default __webpack_public_path__ + "static/media/money_retention_rate.2ee3eedd3d5d7a1c0432f3c873836313.svg";
export { ForwardRef as ReactComponent };